module.exports = __webpack_public_path__ + "img/footer-title.2aecbae4.png";